import { render, staticRenderFns } from "./ResourceCatalogPalette.vue?vue&type=template&id=210ea64c&scoped=true&"
import script from "./ResourceCatalogPalette.vue?vue&type=script&lang=js&"
export * from "./ResourceCatalogPalette.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCatalogPalette.vue?vue&type=style&index=0&id=210ea64c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ea64c",
  null
  
)

export default component.exports